<template>
  <div></div>
</template>

<script>
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'

export default {
  name: 'Toast',
  props: {
    type: {
      type: String,
      default: 'success'
    },
    title: {
      type: String
    },
    text: {
      required: true,
      type: String
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    option () {
      const defaultOptions = {
        closeButton: false,
        debug: false,
        newestOnTop: false,
        progressBar: true,
        rtl: false,
        positionClass: 'toast-top-right',
        preventDuplicates: false,
        onclick: null,
        showDuration: 300,
        hideDuration: 1000,
        timeOut: 3000,
        extendedTimeOut: 1000,
        showEasing: 'swing',
        hideEasing: 'linear',
        showMethod: 'fadeIn',
        hideMethod: 'fadeOut'
      }

      toastr.options = Object.assign({}, defaultOptions, {
        ...this.options
      })
    },
    callbacks () {
      toastr.options.onShown = () => {
        this.$emit('onShown', true)
      }

      toastr.options.onHidden = () => {
        this.$emit('onHidden', true)
      }

      toastr.options.onclick = () => {
        this.$emit('onClick', true)
      }

      toastr.options.onCloseClick = () => {
        this.$emit('onCloseClick', true)
      }
    },
    types () {
      if (this.type === 'success') {
        toastr.success(this.text, this.title || 'Sucesso')
      }

      if (this.type === 'error') {
        toastr.error(this.text, this.title || 'Erro')
      }

      if (this.type === 'info') {
        toastr.info(this.text, this.title || 'Informação')
      }

      if (this.type === 'warning') {
        toastr.warning(this.text, this.title || 'Alerta')
      }
    },
    init () {
      this.option()
      this.callbacks()
      this.types()
    }
  },
  mounted () {
    this.init()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/toast/Toast.vue